import script from "./AppAvatarEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppAvatarEditor.vue?vue&type=script&setup=true&lang=ts"

import "./AppAvatarEditor.vue?vue&type=style&index=0&id=71b4b7b7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71b4b7b7"]])

export default __exports__